export class NoProviderError extends Error {
  constructor(capitalizedContextName: string) {
    super(`use${capitalizedContextName} must be used within a ${capitalizedContextName}Provider`);
    this.name = 'NoProviderError';
  }
}
